<template>
  <TemplateLidBase>
    <main class="relative z-0 col-span-full row-start-2">
      <section
        :class="{
          'mb-32': page.matrix.length,
          'mb-64': !page.matrix.length && !page.references.length,
        }"
      >
        <MoleculeLidHeader class="mb-8 md:mb-10 xl:mb-16" :date="page.date" :title="page.title" :image="page.image" />

        <div class="flex md:grid grid-cols-12 sm:gap-5 lg:gap-8 mx-4 sm:mx-16 md:mx-6 lg:mx-16 xl:mx-24">
          <div class="col-span-full md:col-span-8 md:col-start-3 px-5 sm:px-12 md:px-0">
            <h2 v-if="page.subtitle" class="lid-h2 text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-tight mb-4 lg:mb-8">
              {{ page.subtitle }}
            </h2>

            <!-- Page introduction -->
            <div v-if="page.introduction" class="prose prose--app prose--app--lid mb-6 font-semibold overflow-auto md:mb-10 lg:text-lg" v-html="page.introduction" />

            <!-- Page body text -->
            <div v-if="page.description" class="prose prose--app prose--app--lid overflow-auto mb-5 sm:mb-8 md:mb-10 xl:mb-12 2xl:mb-16" v-html="page.description" />
            <!-- Possible content items -->
            <OrganismMatrix
              v-if="page.matrix.length"
              :items="page.matrix"
              :enable-last-item-rounded="page.references.length > 0"
              :expiry-date="page.expiryDate || null"
              :class="{ 'mb-64': !page.references.length, 'mb-32': page.references.length }"
            />
          </div>
        </div>
      </section>
    </main>
  </TemplateLidBase>
</template>

<script setup lang="ts">
interface Page {
  date: string
  title: string
  image: string
  subtitle?: string
  introduction?: string
  description?: string
  matrix: Array<any>
  references: Array<any>
}

interface Props {
  breadcrumbs?: Array<any>
  page?: Page
}

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
  page: () => ({
    date: '',
    title: '',
    image: '',
    matrix: [],
    references: [],
  }),
})
</script>

<style lang="scss" scoped>
.lid-h2 {
  @screen 2xl {
    font-size: 56px;
  }
}
</style>
